import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";

const initialState = {
    roles: [],
    loading: false,
    error: null,
};

export const getRolesList = createAsyncThunk(
    "usermanagement/rolesList",
    async (user) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.backoffice;
            const endpointpath = endpoint?.backoffice?.role;
            const list = endpoint?.backoffice?.list;
            const institution = user?.institution?.value;
            const isSuperAdmin = true;

            const apiURL = base + endpointpath + list + institution + '/' + isSuperAdmin;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

const rolesListSlice = createSlice({
    name: "roles list",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getRolesList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getRolesList.fulfilled, (state, action) => {
                state.loading = false;
                state.roles = action?.payload || [];
            })
            .addCase(getRolesList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default rolesListSlice.reducer;